import React, { useEffect } from "react";
import { ReactComponent as CheckIcon } from "../../assets/Icons/check.svg";
import { ReactComponent as XIcon } from "../../assets/Icons/x.svg";
import { useHomePage } from "../../contexts/HomePage";
import { SUCCESS, treatment_program } from "../../constants/common";
import PracticeStatusDrawer from "../PracticeStatusDrawer";
import { useBasicInfo } from "../../contexts/BasicInfo";
import { useGeneralProfile } from "../../contexts/Organization";
import { useAuth } from "../../contexts/Auth";
import { trackClickEvent } from "../../mixpanel";
import CustomMenu from "../CustomMenu";

const UpdateStatusMenu = ({
  openStatusDrawer,
  handleCloseStatusDrawer,
  handleOpenStatusDrawer,
  disabled,
}) => {
  const { editCurrentStatus, updateCurrentStatusStatus, updateHomePagetate } =
    useHomePage();
  const { data, fetchInfo } = useBasicInfo();
  const { facilityInfo, fetchFacilityInfo } = useGeneralProfile();
  const { account_type, isMentalHealthProfessional } = useAuth();
  const info =
    account_type === treatment_program && !isMentalHealthProfessional()
      ? facilityInfo
      : data;

  useEffect(() => {
    if (updateCurrentStatusStatus === SUCCESS) {
      updateHomePagetate("updateCurrentStatusStatus", "");
      if (account_type !== treatment_program) fetchInfo();
      else fetchFacilityInfo();
    }
  }, [updateCurrentStatusStatus, account_type]);

  useEffect(() => {
    if (updateCurrentStatusStatus === SUCCESS) {
      updateHomePagetate("updateCurrentStatusStatus", "");
      if (account_type !== treatment_program) fetchInfo();
      else fetchFacilityInfo();
    }
  }, [updateCurrentStatusStatus, account_type]);

  // Under centralized referral routing the practice takes delivery of the
  // referral, so its Accepting / Not Accepting status is the one that applies and
  // the therapist cannot set their own. The menu still shows the inherited value.
  const availabilityInherited = Boolean(info?.availability_inherited);

  const handleUpdateStatus = async (status) => {
    if (availabilityInherited) return;

    if (
      status === "not_accepting_clients" ||
      (info?.info?.accepting_referrals_from &&
        info?.currently_served?.length > 0 &&
        info?.info?.age_served &&
        Object.values(info?.info?.session_types_currently).some((item) => Boolean(item) === true))
    ) {
      trackClickEvent("Changed Availability Status", {
        button: "Changed Availability",
        page: "Homepage",
      });
      await editCurrentStatus({ current_status: status, account_type });
    } else {
      handleOpenStatusDrawer();
    }
  };

  return (
    <>
      <CustomMenu
        currentStatus={info?.info?.current_status}
        createdAt={info?.created_at}
        onUpdateStatus={handleUpdateStatus}
        statusLabels={{
          accepting_new_clients: "Accepting Clients",
          not_accepting_clients: "Fully Booked",
        }}
        statusOptions={[
          {
            value: "accepting_new_clients",
            label: "Accepting Clients",
            icon: <CheckIcon />,
            requiresExtraCondition: true,
            color: "success",
            variant: "outlined",
          },
          {
            value: "not_accepting_clients",
            label: "Fully Booked",
            icon: <XIcon />,
            color: "error",
            variant: "contained",
          },
        ]}
        disabled={disabled || availabilityInherited}
      />

      <PracticeStatusDrawer
        onClose={handleCloseStatusDrawer}
        open={openStatusDrawer}
      />
    </>
  );
};

export default UpdateStatusMenu;
